class TwilsockError extends Error {
  constructor(description: string) {
    super(description);
  }
}

export { TwilsockError };
